// Lightweight CSV→array loader with cache-busting + optional dedupe/sort.
export async function loadCSVList(
  url,
  {
    header = true,        // first row is a header
    unique = false,       // remove duplicates
    sort = false,         // sort ascending (locale-aware)
    normalize = false,    // trim + collapse spaces
  } = {}
) {
  const bust = `v=${Date.now()}`;
  const u = url.includes("?") ? `${url}&${bust}` : `${url}?${bust}`;

  const res = await fetch(u, { cache: "no-store" });
  if (!res.ok) throw new Error(`Failed to fetch ${url}: ${res.status}`);

  const text = await res.text();
  const lines = text.split(/\r?\n/);

  // basic CSV field unquote for single-column lists
  const unquote = (s) => s.replace(/^"|"$/g, "").replace(/""/g, '"');

  let rows = lines
    .map(l => unquote(l.trim()))
    .filter(Boolean);

  if (header && rows.length) rows = rows.slice(1);

  if (normalize) {
    rows = rows.map(s => s.replace(/\s+/g, " ").trim());
  }

  if (unique) {
    const seen = new Set();
    const out = [];
    for (const r of rows) {
      const key = r.toLowerCase(); // case-insensitive dedupe
      if (!seen.has(key)) { seen.add(key); out.push(r); }
    }
    rows = out;
  }

  if (sort) {
    rows = rows.sort((a, b) => a.localeCompare(b));
  }

  return rows;
}